import { render, staticRenderFns } from "./persupplier.vue?vue&type=template&id=c3297262&scoped=true&"
import script from "./persupplier.vue?vue&type=script&lang=js&"
export * from "./persupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3297262",
  null
  
)

export default component.exports